"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliderNeoDark = exports.sliderNeoLight = exports.sliderNovoDark = exports.sliderNovo = exports.slider = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const { light, dark, neoLight, neoDark } = oxygen_theme_1.default;
const slider = {
    sliderHeight: '10px',
    sliderBorder: 'none',
    sliderBorderRadius: size_const_1.default.borderRadiusMedium,
    sliderTrackBorderRadius: size_const_1.default.borderRadiusMedium,
    sliderTrackBackgroundColor: color_const_1.default.cloudyBlue300,
    sliderActiveTrackBackgroundColor: color_const_1.default.pickledBluewood,
    sliderActiveTrackBackgroundColorActive: color_const_1.default.pickledBluewood,
    sliderActiveTrackBackgroundColorDisabled: color_const_1.default.steel700,
    sliderKnobSize: size_const_1.default.default2x,
    sliderKnobColor: color_const_1.default.white,
    sliderKnobColorActive: color_const_1.default.white,
    sliderKnobColorDisabled: color_const_1.default.white,
    sliderKnobBorderColor: color_const_1.default.pickledBluewood,
    sliderKnobBorderColorDisabled: color_const_1.default.steel700,
    sliderKnobBorderWidth: 1,
    sliderKnobBorderRadius: '50%',
    sliderKnobShadow: 'none',
    sliderKnobPulse: false,
    sliderFocusedOuterBorderColor: '#0056E0',
    sliderFocusedInnerBorderColor: color_const_1.default.white,
};
exports.slider = slider;
const sliderNovo = {
    sliderHeight: light.spacing02,
    sliderBorder: 'none',
    sliderBorderRadius: light.spacing01,
    sliderTrackBorderRadius: light.spacing01,
    sliderTrackBackgroundColor: light.ui03,
    sliderActiveTrackBackgroundColor: light.ui04,
    sliderActiveTrackBackgroundColorActive: light.action04,
    sliderActiveTrackBackgroundColorDisabled: light.disabled02,
    sliderKnobSize: `16px`,
    sliderKnobColor: light.ui04,
    sliderKnobColorActive: light.action04,
    sliderKnobColorDisabled: light.disabled02,
    sliderKnobBorderColor: light.ui04,
    sliderKnobBorderColorDisabled: light.disabled02,
    sliderKnobBorderWidth: 0,
    sliderKnobBorderRadius: '50%',
    sliderKnobShadow: 'none',
    sliderKnobPulse: true,
    sliderFocusedOuterBorderColor: light.focus01,
    sliderFocusedInnerBorderColor: light.ui06,
};
exports.sliderNovo = sliderNovo;
const sliderNovoDark = {
    ...sliderNovo,
    sliderTrackBackgroundColor: dark.ui03,
    sliderActiveTrackBackgroundColor: dark.ui04,
    sliderActiveTrackBackgroundColorActive: dark.action04,
    sliderActiveTrackBackgroundColorDisabled: dark.disabled02,
    sliderKnobColor: dark.ui04,
    sliderKnobColorActive: dark.action04,
    sliderKnobColorDisabled: dark.disabled02,
    sliderKnobBorderColor: dark.ui04,
    sliderKnobBorderColorDisabled: dark.disabled02,
    sliderFocusedOuterBorderColor: dark.focus01,
    sliderFocusedInnerBorderColor: dark.ui06,
};
exports.sliderNovoDark = sliderNovoDark;
const sliderNeoLight = {
    ...sliderNovo,
    sliderTrackBackgroundColor: neoLight.ui03,
    sliderActiveTrackBackgroundColor: neoLight.ui04,
    sliderActiveTrackBackgroundColorActive: neoLight.action04,
    sliderActiveTrackBackgroundColorDisabled: neoLight.disabled02,
    sliderKnobColor: neoLight.ui04,
    sliderKnobColorActive: neoLight.action04,
    sliderKnobColorDisabled: neoLight.disabled02,
    sliderKnobBorderColor: neoLight.ui04,
    sliderKnobBorderColorDisabled: neoLight.disabled02,
    sliderFocusedOuterBorderColor: neoLight.focus01,
    sliderFocusedInnerBorderColor: neoLight.ui06,
};
exports.sliderNeoLight = sliderNeoLight;
const sliderNeoDark = {
    ...sliderNovoDark,
    sliderTrackBackgroundColor: neoDark.ui03,
    sliderActiveTrackBackgroundColor: neoDark.ui04,
    sliderActiveTrackBackgroundColorActive: neoDark.action04,
    sliderActiveTrackBackgroundColorDisabled: neoDark.disabled02,
    sliderKnobColor: neoDark.ui04,
    sliderKnobColorActive: neoDark.action04,
    sliderKnobColorDisabled: neoDark.disabled02,
    sliderKnobBorderColor: neoDark.ui04,
    sliderKnobBorderColorDisabled: neoDark.disabled02,
    sliderFocusedOuterBorderColor: neoDark.focus01,
    sliderFocusedInnerBorderColor: neoDark.ui06,
};
exports.sliderNeoDark = sliderNeoDark;
